import { render, staticRenderFns } from "./BaseHeader.vue?vue&type=template&id=a91f8024"
import script from "./BaseHeader.vue?vue&type=script&lang=js"
export * from "./BaseHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a91f8024')) {
      api.createRecord('a91f8024', component.options)
    } else {
      api.reload('a91f8024', component.options)
    }
    module.hot.accept("./BaseHeader.vue?vue&type=template&id=a91f8024", function () {
      api.rerender('a91f8024', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseHeader.vue"
export default component.exports